const baseUrl = process.env.REACT_APP_API_ENDPOINT_GRAPHQL;

export const fetchGraphQl = async (data: any = null, token: any = null): Promise<any> => {
  const headers: Headers = new Headers();
  headers.append('Content-Type', 'application/json');

  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }

  const config: any = {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  };

  try {
    const response: Response = await fetch(`${baseUrl}`, config);

    if (!response.ok) {
      if (response.status === 401) {
        window.location.replace('/');
      }

      if (response.status === 403) {
        console.log('Forbiden');
      }

      if (response.status >= 500) {
        window.location.href = '/server-error';
        return;
      }

      const errorBody: any = await response.json();
      throw new Error(JSON.stringify(errorBody) || 'Une erreur réseau est survenue');
    }

    return response.status === 204 ? null : response.json();
  } catch (error) {
    console.error('Erreur lors de la requête:', error);
    throw error;
  }
};
